PJQ.views.invoicing.PayableInvoiceDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Payable Invoices have been created yet',
            zeroRecords: "No Payable Invoices matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'data-table-header-payable-invoices')
        },
        toggleRowClass: '.change-order-toggle-row',
        onViewInvoice: null
    },
    events: {
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .view-commitment': 'viewCommitmentClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.payable-invoice-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER, this.getDefaultFilter());

        let currentBillingPeriod = _.find(this.options.billingPeriodSettings.billingPeriods.models, function (period) {
                return period.get('isCurrent');
            }),
            bpId = currentBillingPeriod && !this.options.showAllBillingPeriods ? currentBillingPeriod.id : null;
        this.setFilter('billingPeriodId', bpId);
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: bpId,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.setFilter('billingPeriodId', value);
            }, this)
        });
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.invoicing.filterType.STATUS_FILTER),
            billingPeriodFilter = this.getFilter('billingPeriodId'),
            data = this.options.data;
        if (_.size(statusFilter) === 0 && billingPeriodFilter == null) {
            return data;
        }

        if (billingPeriodFilter != null) {
            let fnBPFilter = _.bind(function (data) {
                let billingPeriod = this.options.billingPeriodSettings.billingPeriods.get(billingPeriodFilter),
                    startA = billingPeriod.get('startDate'),
                    endA = billingPeriod.get('endDate');
                return _.filter(data, function (row) {
                    let startB = row.get('startDate'),
                        endB = row.get('endDate');
                    return billingPeriodFilter === row.get('billingPeriodId') || PJQ.helpers.dateHelpers.checkDateRangesOverlap(startA, endA, startB, endB);
                });
            }, this);
            return fnBPFilter(_.filter(data, function (row) {
                return _.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId'));
            }));
        } else {
            return _.filter(data, function (row) {
                return _.contains(statusFilter, row.get('statusId'));
            });
        }
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');

        let columns = [],
            includeColumns = ['number', 'commitment', 'contractedContact.companyName', 'billingDate', 'startDate', 'endDate', 'status', 'amount', 'taxAmount', 'grandTotal', 'paymentAmount', 'paid'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.invoicing.payableInvoiceStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-invoice" href="javascript:void(0)" data-id="' + row.get('number') + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'commitment':
                    columns.push({
                        "columnData": "commitment",
                        "title": "Commitment",
                        "data": "attributes.commitmentNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('commitmentNumber');
                            }

                            if (this.options.canViewCommitments) {
                                return '<a class="view-commitment" href="javascript:void(0)" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'notes':
                    columns.push({
                        "columnData": "notes",
                        "data": "attributes.notes",
                        "title": "Notes"
                    });
                    break;
                case 'billingDate':
                    columns.push({
                        "columnData": "billingDate",
                        "data": "attributes.billingDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'endDate':
                    columns.push({
                        "columnData": "endDate",
                        "data": "attributes.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'paymentAmount':
                    columns.push({
                        "columnData": "paymentAmount",
                        "data": "attributes.paymentAmount",
                        "title": "Payments",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'paid':
                    columns.push({
                        "columnData": "paid",
                        "data": "attributes.paid",
                        "title": "Paid",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return data ? 'Yes' : 'No';
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-invoice ml-1" title="View invoice"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.commitments.ChangeOrderLineItems(null, {
            changeOrderId: row.data().id
        });
    },
    viewInvoiceClicked: function (e) {
        if (typeof (this.options.onViewInvoice) === 'function') {
            let row = this.getRow((e.currentTarget).closest('tr')),
                invoice = row.data();
            if (invoice != null) {
                this.options.onViewInvoice(invoice);
            }
        }
    },
    viewCommitmentClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewCommitment(row.data().get('commitmentId'));
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    }
});